import React, { useState, useEffect, useCallback } from "react";

function BackToTop() {
  const [visible, setVisible] = useState(false);

  const toggleVisibility = useCallback(() => {
    const offset = window.pageYOffset;
    if (offset > 300) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, []);

  // Функция для плавной прокрутки вверх
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, [toggleVisibility]);

  return (
    <button
      type="button"
      className="physical-button fixed bottom-5 right-5 z-40 inline-flex items-center gap-2 rounded-full border border-line bg-surface px-4 py-3 text-sm font-semibold text-ink shadow-lg backdrop-blur-md transition-all duration-300 sm:bottom-6 sm:right-6"
      onClick={scrollToTop}
      style={{
        opacity: visible ? 1 : 0,
        visibility: visible ? "visible" : "hidden",
        transform: visible ? "translateY(0) scale(1)" : "translateY(20px) scale(0.96)",
      }}
      aria-label="Back to top"
    >
      <span className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-accent/10 text-accent">
        ↑
      </span>
      <span>Back to top</span>
    </button>
  );
}

export default BackToTop;
